import { render, staticRenderFns } from "./add_freight.vue?vue&type=template&id=52e92b41&scoped=true&"
import script from "./add_freight.vue?vue&type=script&lang=js&"
export * from "./add_freight.vue?vue&type=script&lang=js&"
import style0 from "./add_freight.vue?vue&type=style&index=0&id=52e92b41&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e92b41",
  null
  
)

export default component.exports